import { captureException } from '@sentry/browser';

export default function reportReactError(error, errorInfo) {
  captureException(error, errorInfo);
}
